import { Filter } from "lucide-react";

import { cn } from "@/shared/lib/utils";
import { MEDIA_STATUS_OPTIONS, type MediaStatusFilter } from "../lib/mediaStatusFilter";

/**
 * 历史节的状态筛选 chips(2026-07-16 三线共用)。
 *
 * 口径(含「为什么没有『生成中』」)见 {@link ../lib/mediaStatusFilter}。
 */
export function MediaFilterChips({
  value,
  onChange,
}: {
  value: MediaStatusFilter;
  onChange: (v: MediaStatusFilter) => void;
}) {
  return (
    <div className="flex w-fit items-center gap-1 rounded-lg border bg-muted/40 p-1">
      <Filter className="ml-1 h-3.5 w-3.5 shrink-0 text-muted-foreground" />
      {MEDIA_STATUS_OPTIONS.map((o) => (
        <button
          key={o.value}
          type="button"
          onClick={() => onChange(o.value)}
          aria-pressed={value === o.value}
          className={cn(
            "rounded px-2 py-0.5 text-2xs transition-colors",
            value === o.value
              ? "bg-background font-medium text-foreground shadow-sm"
              : "text-muted-foreground hover:text-foreground"
          )}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
